<script>
import KeepOnRecord from "@/layouts/website/components/WF/KeepOnRecord.vue";
import WFLine from "@/layouts/website/components/WF/WFLine.vue";
import QuickNavigation from "@/layouts/website/components/WF/QuickNavigation.vue";
import QrCodeDisplay from "@/layouts/website/components/WF/QrCodeDisplay.vue";

export default {
  name: "WebsiteFooter",
  components: {QrCodeDisplay, QuickNavigation, WFLine, KeepOnRecord},
};
</script>

<template>
  <div class="website-footer">

    <div class="w-f-content">
      <KeepOnRecord/>
      <WFLine/>
      <QuickNavigation/>
      <WFLine/>
      <QrCodeDisplay/>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.website-footer {
  background-color: #4f4f4f;
  height: 260px;
  color: #a7a7a7;
  padding: 0 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  .w-f-content {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1px 1fr 1px 1fr;
    gap: 0.6em;
  }

}
</style>
